import { faCommentCheck, faCommentQuestion } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { theme } from '@/theme/theme'
import LoadingContainer from '../LoadingContainer/LoadingContainer'
import { VideoResult } from '@/types/videos'

type QuizPreviewParams = { video: VideoResult }

const QuizPreview: FC<QuizPreviewParams> = ({ video }) => {
  const { t } = useTranslation()
  if (!video || !video.quiz_questions_with_answers) {
    return <LoadingContainer />
  }

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography fontSize={18} fontWeight={theme.typography.fontWeightSemiBold}>
          {t('QuizPreview.title')}
        </Typography>
        <Button
          variant="outlined"
          onClick={() => window.open(`/content/quiz/preview/${video.quizzes?.[0]?._id}`, '_blank')}>
          {t('QuizPreview.viewQuiz')}
        </Button>
      </Box>
      <Box display="flex" flexDirection="column" gap={4} paddingTop={4}>
        {video.quiz_questions_with_answers.map((question) => {
          return (
            <Box>
              <Box display="flex" gap={1} alignItems="center" paddingBottom={1}>
                <FontAwesomeIcon icon={faCommentQuestion}></FontAwesomeIcon>
                <Typography>{question.question_translations.en}</Typography>
              </Box>
              <Box display="flex" gap={1} alignItems="center">
                <FontAwesomeIcon icon={faCommentCheck} color={theme.palette.green[900]}></FontAwesomeIcon>
                <Typography fontWeight={theme.typography.fontWeightSemiBold}>
                  {question.answers.find((answer) => answer.is_correct)?.answer_translations.en}
                </Typography>
              </Box>
            </Box>
          )
        })}
      </Box>
    </>
  )
}

export default QuizPreview
